import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 贵宾列表
 * @returns 
 */
export const fetchList = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_LOUNGE_LIST, { params })
  return res.data.data ?? {};
}

/**
 * 预约时间段
 * @returns 
 */
export const fetchTimeDate = async (params) => {
  const res = await GET(APIs.API_SUBSCRIBE_LOUNGE_ROOMDATA, { params })
  return res.data?.data?.time_slot ?? {};
}

/**
 * 确认入场
 * @returns 
 */
export const fetchCheckIn = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_LOUNGE_CHECKIN, { data })
  return res.data ?? {};
}

/**
 * 撤销入场
 * @returns 
 */
export const fetchRevokeIn = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_LOUNGE_REVOKEIN, { data })
  return res.data ?? {};
}

/**
 * 确认出场
 * @returns 
 */
export const fetchCheckOut = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_LOUNGE_CHECKOUT, { data })
  return res.data ?? {};
}

/**
 * 确认出场
 * @returns 
 */
export const fetchUpdate = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_LOUNGE_UPDATE_CONTENT, { data })
  return res.data ?? {};
}

/**
 * 确认NoShow
 * @returns 
 */
export const fetchNoShowVip = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_LOUNGE_NOSHOWVIP, { data })
  return res.data ?? {};
}

/**
 * 撤销NoShow
 * @returns 
 */
export const fetchRevokeNoShowVip = async (data) => {
  const res = await POST(APIs.API_SUBSCRIBE_LOUNGE_REVOKENOSHOWVIP, { data })
  return res.data ?? {};
}

/**
 * 贵宾休息室详情
 */
export const fetchViproomInfo = async (service_id) => {
  const res = await GET(APIs.API_SERVICE_VIPROOMINFO, { params: { service_id } });

  return res.data.data ?? {};
};

/**
 * 编辑贵宾休息室
 */
export const fetchEditViproom = async (data) => {
  const res = await POST(APIs.API_SERVICE_EDITVIPROOM, { data });

  return res.data.data ?? {};
};
